import { Api } from '@/types'
import { DateTime } from 'luxon';

export const normalizeArrayResponse = <T>(value: unknown): T[] => {
	let current = value;

	// Collections may be returned directly or wrapped by API resources/pagination.
	for (let depth = 0; depth < 3; depth++) {
		if (Array.isArray(current)) {
			return current as T[];
		}

		if (current && typeof current === 'object' && 'data' in current) {
			current = (current as { data: unknown }).data;
			continue;
		}

		break;
	}

	return [];
}

export const filterComponentData = (
	dataArr: Array<Api.Material | Api.Equipment | any> | unknown,
	filterKey: string
) => {
	return normalizeArrayResponse<Api.Material | Api.Equipment>(dataArr).filter(
		(data: Api.Material | Api.Equipment) =>
			data.myoctans_display === filterKey || data.myoctans_display === 'both'
	)
}

export const filterTasks = (
	dataArr: Array<Api.Task | any>,
	filterKey: number
) => {
	if (filterKey === 0) {
		return dataArr;
	}
	var result = dataArr.filter(
		(data: Api.Task) =>
			data.project_id === filterKey
	);
	return result;
}

export const hoursToTime = (hours: number) => {
	const h = Math.floor(hours).toString().padStart(2, '0');
	const m = Math.round((hours - Math.floor(hours)) * 60).toString().padStart(2, '0');
	return `${h}:${m}`;
}

export const setNestedValue = (obj: any, path: string, value: any) => {
	const parts = path.split('.');
	const last = parts.pop();
	const target = parts.reduce((acc, part) => acc && acc[part], obj);
	if (target && last) {
		target[last] = value;
	}
};

export const formDataToJson = (formData: FormData): Record<string, any> => {
	const jsonObject: Record<string, any> = {};

	for (const [key, value] of formData.entries()) {
		let isArray = false;
		if (key.endsWith('[]')) {
			isArray = true;
		}
		const keys = key.split(/\[|\]/).filter((k: string) => k);
		let current = jsonObject;
		keys.forEach((k: string, index: number) => {
			if (index === keys.length - 1) {
				if (Array.isArray(current[k])) {
					current[k].push(value);
				} else if (current[k] !== undefined) {
					current[k] = [current[k], value];
				} else if (isArray) {
					current[k] = [value];
				} else {
					current[k] = value;
				}
			} else {
				if (!current[k]) {
					current[k] = isNaN(Number(keys[index + 1])) ? {} : [];
				}
				current = current[k];
			}
		});
	}

	return jsonObject;
};

export function appendFormData(formData: FormData, data: any, parentKey = '') {
	for (const key in data) {
		if (data.hasOwnProperty(key)) {
			const value = data[key];
			const formKey = parentKey ? `${parentKey}[${key}]` : key;
			if (value instanceof File) {
				formData.append(formKey, value);
			} else if (value !== null && typeof value === 'object') {
				appendFormData(formData, value, formKey);
			} else {
				formData.append(formKey, value);
			}
		}
	}
}

export function isNumeric(value?: any): value is number {
	return !isNaN(value) && !isNaN(parseFloat(value));
}

export function upsert(array: Array<any>, newItem: any) {
	const index = array.findIndex(item => item.id == newItem.id);
	if (index !== -1) {
		array[index] = newItem;
	} else {
		array.push(newItem);
	}
	return array;
}

export function parseDate(dateString: string): DateTime {
	let dt = DateTime.fromFormat(dateString, 'yyyy-MM-dd HH:mm:ss')
	if (!dt.isValid) {
		dt = DateTime.fromISO(dateString)
	}
	return dt
}
